/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateScheduledBreakData } from './CreateScheduledBreakData';
import {
    CreateScheduledBreakDataFromJSON,
    CreateScheduledBreakDataFromJSONTyped,
    CreateScheduledBreakDataToJSON,
    CreateScheduledBreakDataToJSONTyped,
} from './CreateScheduledBreakData';
import type { CreateShiftAreaSessionData } from './CreateShiftAreaSessionData';
import {
    CreateShiftAreaSessionDataFromJSON,
    CreateShiftAreaSessionDataFromJSONTyped,
    CreateShiftAreaSessionDataToJSON,
    CreateShiftAreaSessionDataToJSONTyped,
} from './CreateShiftAreaSessionData';

/**
 * 
 * @export
 * @interface UpdateShiftData
 */
export interface UpdateShiftData {
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftData
     */
    employeeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftData
     */
    jobRoleId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftData
     */
    locationId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateShiftData
     */
    absenceId?: number | null;
    /**
     * Whether to offer the shift to all eligible employees
     * @type {boolean}
     * @memberof UpdateShiftData
     */
    open?: boolean;
    /**
     * Whether the system can auto-assign employees when they respond to an open shift
     * @type {boolean}
     * @memberof UpdateShiftData
     */
    requiresApproval?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateShiftData
     */
    tags?: Array<number> | null;
    /**
     * 
     * @type {Date}
     * @memberof UpdateShiftData
     */
    startsAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateShiftData
     */
    endsAt?: Date;
    /**
     * Whether to show the shift end time to non-managerial staff
     * @type {boolean}
     * @memberof UpdateShiftData
     */
    showEndTime?: boolean;
    /**
     * Whether to show the job role to non-managerial staff
     * @type {boolean}
     * @memberof UpdateShiftData
     */
    showJobRole?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShiftData
     */
    published?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateShiftData
     */
    acknowledged?: boolean;
    /**
     * 
     * @type {Array<CreateScheduledBreakData>}
     * @memberof UpdateShiftData
     */
    scheduledBreaks?: Array<CreateScheduledBreakData>;
    /**
     * 
     * @type {Array<CreateShiftAreaSessionData>}
     * @memberof UpdateShiftData
     */
    shiftAreaSessions?: Array<CreateShiftAreaSessionData>;
    /**
     * 
     * @type {string}
     * @memberof UpdateShiftData
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the UpdateShiftData interface.
 */
export function instanceOfUpdateShiftData(value: object): value is UpdateShiftData {
    return true;
}

export function UpdateShiftDataFromJSON(json: any): UpdateShiftData {
    return UpdateShiftDataFromJSONTyped(json, false);
}

export function UpdateShiftDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateShiftData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'] == null ? undefined : json['employeeId'],
        'jobRoleId': json['jobRoleId'] == null ? undefined : json['jobRoleId'],
        'locationId': json['locationId'] == null ? undefined : json['locationId'],
        'absenceId': json['absenceId'] == null ? undefined : json['absenceId'],
        'open': json['open'] == null ? undefined : json['open'],
        'requiresApproval': json['requiresApproval'] == null ? undefined : json['requiresApproval'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'startsAt': json['startsAt'] == null ? undefined : (new Date(json['startsAt'])),
        'endsAt': json['endsAt'] == null ? undefined : (new Date(json['endsAt'])),
        'showEndTime': json['showEndTime'] == null ? undefined : json['showEndTime'],
        'showJobRole': json['showJobRole'] == null ? undefined : json['showJobRole'],
        'published': json['published'] == null ? undefined : json['published'],
        'acknowledged': json['acknowledged'] == null ? undefined : json['acknowledged'],
        'scheduledBreaks': json['scheduledBreaks'] == null ? undefined : ((json['scheduledBreaks'] as Array<any>).map(CreateScheduledBreakDataFromJSON)),
        'shiftAreaSessions': json['shiftAreaSessions'] == null ? undefined : ((json['shiftAreaSessions'] as Array<any>).map(CreateShiftAreaSessionDataFromJSON)),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

  export function UpdateShiftDataToJSON(json: any): UpdateShiftData {
      return UpdateShiftDataToJSONTyped(json, false);
  }

  export function UpdateShiftDataToJSONTyped(value?: UpdateShiftData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'jobRoleId': value['jobRoleId'],
        'locationId': value['locationId'],
        'absenceId': value['absenceId'],
        'open': value['open'],
        'requiresApproval': value['requiresApproval'],
        'tags': value['tags'],
        'startsAt': value['startsAt'] == null ? undefined : ((value['startsAt']).toISOString()),
        'endsAt': value['endsAt'] == null ? undefined : ((value['endsAt']).toISOString()),
        'showEndTime': value['showEndTime'],
        'showJobRole': value['showJobRole'],
        'published': value['published'],
        'acknowledged': value['acknowledged'],
        'scheduledBreaks': value['scheduledBreaks'] == null ? undefined : ((value['scheduledBreaks'] as Array<any>).map(CreateScheduledBreakDataToJSON)),
        'shiftAreaSessions': value['shiftAreaSessions'] == null ? undefined : ((value['shiftAreaSessions'] as Array<any>).map(CreateShiftAreaSessionDataToJSON)),
        'notes': value['notes'],
    };
}

